export enum AddToBasketModal {
  Basic = 'basic_modal',
  ModalWithMembershipOffer = 'modal_with_membership_offer',
  NAME = 'add_to_basket_modal',
  None = 'no_modal',
}
